import { Button } from "@circleco/compass/components/Button";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import type { ComponentPropsWithoutRef } from "react";

type HeaderActionProps = {
  label: string;
  onClick: () => void;
} & (
  | {
      kind: "text";
      startIcon: ComponentPropsWithoutRef<typeof Button>["startIcon"];
    }
  | { kind: "icon"; icon: ComponentPropsWithoutRef<typeof IconButton>["icon"] }
);

export const HeaderAction = ({
  label,
  onClick,
  ...props
}: HeaderActionProps) => (
  <li>
    <Tooltip content={label} side="bottom">
      {props.kind === "text" ? (
        <Button
          type="button"
          variant="outline"
          size="md"
          startIcon={props.startIcon}
          onClick={onClick}
          aria-label={label}
        >
          {label}
        </Button>
      ) : (
        <IconButton
          variant="outline"
          size="md"
          icon={props.icon}
          onClick={onClick}
          aria-label={label}
        />
      )}
    </Tooltip>
  </li>
);
